import { styled } from '@mui/material';

import { Box, Icon, Text } from 'shell/components';

const IconDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Icon</Text>
            <Box
                sx={{
                    display: 'flex',
                    flexFlow: 'row wrap',
                    gap: (theme) => theme.spacing(2),
                }}
            >
                <CustomBox>
                    <Icon kind={'add'} />
                    <Text variant={'p2'}>add</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'announcement'} />
                    <Text variant={'p2'}>announcement</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'arrowDown'} />
                    <Text variant={'p2'}>arrowDown</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'arrowLeft'} />
                    <Text variant={'p2'}>arrowLeft</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'arrowRight'} />
                    <Text variant={'p2'}>arrowRight</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'arrowUp'} />
                    <Text variant={'p2'}>arrowUp</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'attach'} />
                    <Text variant={'p2'}>attach</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'avatar'} />
                    <Text variant={'p2'}>avatar</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'bell'} />
                    <Text variant={'p2'}>bell</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'bold'} />
                    <Text variant={'p2'}>bold</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'bookmarkFilled'} />
                    <Text variant={'p2'}>bookmarkFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'bookmarkOutlined'} />
                    <Text variant={'p2'}>bookmarkOutlined</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'calendar'} />
                    <Text variant={'p2'}>calendar</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'call'} />
                    <Text variant={'p2'}>call</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'callDisabled'} />
                    <Text variant={'p2'}>callDisabled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'callIncoming'} />
                    <Text variant={'p2'}>callIncoming</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'callOutgoing'} />
                    <Text variant={'p2'}>callOutgoing</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'canada'} />
                    <Text variant={'p2'}>canada</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'channel'} />
                    <Text variant={'p2'}>channel</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'checkmark'} />
                    <Text variant={'p2'}>checkmark</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'chevronDown'} />
                    <Text variant={'p2'}>chevronDown</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'chevronLeft'} />
                    <Text variant={'p2'}>chevronLeft</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'chevronRight'} />
                    <Text variant={'p2'}>chevronRight</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'chevronUp'} />
                    <Text variant={'p2'}>chevronUp</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'clock'} />
                    <Text variant={'p2'}>clock</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'code'} />
                    <Text variant={'p2'}>code</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'copy'} />
                    <Text variant={'p2'}>copy</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'dashboard'} />
                    <Text variant={'p2'}>dashboard</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'delete'} />
                    <Text variant={'p2'}>delete</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'download'} />
                    <Text variant={'p2'}>download</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'dropdownArrowDown'} />
                    <Text variant={'p2'}>dropdownArrowDown</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'dropdownArrowUp'} />
                    <Text variant={'p2'}>dropdownArrowUp</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'edit'} />
                    <Text variant={'p2'}>edit</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'email'} />
                    <Text variant={'p2'}>email</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'ensightful'} />
                    <Text variant={'p2'}>ensightful</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'error'} />
                    <Text variant={'p2'}>error</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'exit'} />
                    <Text variant={'p2'}>exit</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'favoriteEmpty'} />
                    <Text variant={'p2'}>favoriteEmpty</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'favoriteFilled'} />
                    <Text variant={'p2'}>favoriteFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileCSV'} />
                    <Text variant={'p2'}>fileCSV</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileExcel'} />
                    <Text variant={'p2'}>fileExcel</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileImg'} />
                    <Text variant={'p2'}>fileImg</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'filePDF'} />
                    <Text variant={'p2'}>filePDF</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'filePPT'} />
                    <Text variant={'p2'}>filePPT</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeDoc'} />
                    <Text variant={'p2'}>fileTypeDoc</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeGif'} />
                    <Text variant={'p2'}>fileTypeGif</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeJpg'} />
                    <Text variant={'p2'}>fileTypeJpg</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypePdf'} />
                    <Text variant={'p2'}>fileTypePdf</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypePng'} />
                    <Text variant={'p2'}>fileTypePng</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeSvg'} />
                    <Text variant={'p2'}>fileTypeSvg</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeTxt'} />
                    <Text variant={'p2'}>fileTypeTxt</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeUndefined'} />
                    <Text variant={'p2'}>fileTypeUndefined</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeVideo'} />
                    <Text variant={'p2'}>fileTypeVideo</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileTypeZip'} />
                    <Text variant={'p2'}>fileTypeZip</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileUnknown'} />
                    <Text variant={'p2'}>fileUnknown</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileUploaded'} />
                    <Text variant={'p2'}>fileUploaded</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileWord'} />
                    <Text variant={'p2'}>fileWord</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fileZIP'} />
                    <Text variant={'p2'}>fileZIP</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'filter'} />
                    <Text variant={'p2'}>filter</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'folder'} />
                    <Text variant={'p2'}>folder</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'formatSelected'} />
                    <Text variant={'p2'}>formatSelected</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'formatDeselected'} />
                    <Text variant={'p2'}>formatDeselected</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fullScreenEnter'} />
                    <Text variant={'p2'}>fullScreenEnter</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'fullScreenExit'} />
                    <Text variant={'p2'}>fullScreenExit</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'graphBarEmpty'} />
                    <Text variant={'p2'}>graphBarEmpty</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'graphPieEmpty'} />
                    <Text variant={'p2'}>graphPieEmpty</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'graphPieFilled'} />
                    <Text variant={'p2'}>graphPieFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'hamburger'} />
                    <Text variant={'p2'}>hamburger</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'hashtag'} />
                    <Text variant={'p2'}>hashtag</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'help'} />
                    <Text variant={'p2'}>help</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'hide'} />
                    <Text variant={'p2'}>hide</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'home'} />
                    <Text variant={'p2'}>home</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'info'} />
                    <Text variant={'p2'}>info</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'italic'} />
                    <Text variant={'p2'}>italic</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'link'} />
                    <Text variant={'p2'}>link</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'listOrdered'} />
                    <Text variant={'p2'}>listOrdered</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'listUnordered'} />
                    <Text variant={'p2'}>listUnordered</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'locationEmpty'} />
                    <Text variant={'p2'}>locationEmpty</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'locationFilled'} />
                    <Text variant={'p2'}>locationFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'lock'} />
                    <Text variant={'p2'}>lock</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'logout'} />
                    <Text variant={'p2'}>logout</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'message'} />
                    <Text variant={'p2'}>message</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'messageFilled'} />
                    <Text variant={'p2'}>messageFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'messageRectangular'} />
                    <Text variant={'p2'}>messageRectangular</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'mic'} />
                    <Text variant={'p2'}>mic</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'moreHorizontal'} />
                    <Text variant={'p2'}>moreHorizontal</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'pageJumpLeft'} />
                    <Text variant={'p2'}>pageJumpLeft</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'pageJumpRight'} />
                    <Text variant={'p2'}>pageJumpRight</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'photo'} />
                    <Text variant={'p2'}>photo</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'preview'} />
                    <Text variant={'p2'}>preview</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'randomize'} />
                    <Text variant={'p2'}>randomize</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'refresh'} />
                    <Text variant={'p2'}>refresh</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'remove'} />
                    <Text variant={'p2'}>remove</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'reorder'} />
                    <Text variant={'p2'}>reorder</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'reply'} />
                    <Text variant={'p2'}>reply</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'resync'} />
                    <Text variant={'p2'}>resync</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'save'} />
                    <Text variant={'p2'}>save</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'search'} />
                    <Text variant={'p2'}>search</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'send'} />
                    <Text variant={'p2'}>send</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'settings'} />
                    <Text variant={'p2'}>settings</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'smile'} />
                    <Text variant={'p2'}>smile</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'sort'} />
                    <Text variant={'p2'}>sort</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'soundMuted'} />
                    <Text variant={'p2'}>soundMuted</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'starEmpty'} />
                    <Text variant={'p2'}>starEmpty</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'starFilled'} />
                    <Text variant={'p2'}>starFilled</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'stopWatch'} />
                    <Text variant={'p2'}>stopWatch</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'subtask'} />
                    <Text variant={'p2'}>subtask</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'task'} />
                    <Text variant={'p2'}>task</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'taskBoard'} />
                    <Text variant={'p2'}>taskBoard</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'teams'} />
                    <Text variant={'p2'}>teams</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'textAlignLeft'} />
                    <Text variant={'p2'}>textAlignLeft</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'textAlignRight'} />
                    <Text variant={'p2'}>textAlignRight</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'thumbsDown'} />
                    <Text variant={'p2'}>thumbsDown</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'thumbsUp'} />
                    <Text variant={'p2'}>thumbsUp</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'timeline'} />
                    <Text variant={'p2'}>timeline</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'underline'} />
                    <Text variant={'p2'}>underline</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'unlock'} />
                    <Text variant={'p2'}>unlock</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'upload'} />
                    <Text variant={'p2'}>upload</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'usa'} />
                    <Text variant={'p2'}>usa</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'video'} />
                    <Text variant={'p2'}>video</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'visible'} />
                    <Text variant={'p2'}>visible</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'web'} />
                    <Text variant={'p2'}>web</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'zoomIn'} />
                    <Text variant={'p2'}>zoomIn</Text>
                </CustomBox>
                <CustomBox>
                    <Icon kind={'zoomOut'} />
                    <Text variant={'p2'}>zoomOut</Text>
                </CustomBox>
            </Box>
        </>
    );
};

const CustomBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
    borderRadius: '4px',
    padding: theme.spacing(2),
}));

export default IconDemo;
